import { Box, Flex, styled, Text, UserAvatar } from '@driftt/dds'
import React from 'react'

import AISparklesIcon from 'components/AISparklesIcon'

import './style.css'

export const WidgetMessage = ({
  messageText,
  backgroundColor,
  fontColor,
  bold = false,
}: {
  messageText: string
  backgroundColor: string
  fontColor?: string
  bold?: boolean
}) => {
  return (
    <Box css={{ backgroundColor, padding: '$1', borderRadius: '$1' }}>
      <Text
        dangerouslySetInnerHTML={{ __html: messageText }}
        css={{ color: fontColor, fontWeight: bold ? 'bold' : 'normal' }}
      />
    </Box>
  )
}

const PendingDot = styled('div', {
  borderRadius: '50%',
  border: '1px solid $white',
  background: '$black',
  width: 6,
  height: 6,
  animation: 'dot ease-in-out 1s infinite',
})

export const PendingMessage = () => (
  <Flex
    css={{ background: '$gray2', padding: '$1', gap: '$0' }}
    alignItems="center"
    justifyContent="space-around"
  >
    <PendingDot />
    <PendingDot />
    <PendingDot />
  </Flex>
)

export const BotMessage = ({
  messageString,
  botUser,
  backgroundColor = '#f5f8fa',
  isValidatedPromptType = false,
}: {
  messageString: string
  botUser: {
    avatarUrl: string
    name: string
  }
  backgroundColor?: string
  isValidatedPromptType?: boolean
}) => {
  return (
    <Box>
      <Box>
        <Text css={{ paddingLeft: 40, fontSize: 10 }}>{`${botUser.name}${
          isValidatedPromptType ? "'s validated prompt result:" : ''
        }`}</Text>
        <Flex alignItems="center">
          <Flex alignItems="flex-end">
            <UserAvatar
              imageUrl={botUser.avatarUrl}
              size="x-small"
              status="available"
            />
            <WidgetMessage
              messageText={messageString}
              backgroundColor={backgroundColor}
              bold={isValidatedPromptType}
            />
          </Flex>
          {isValidatedPromptType && <AISparklesIcon />}
        </Flex>
      </Box>
    </Box>
  )
}

export const BotTypingMessage = ({
  botUser,
}: {
  botUser: {
    avatarUrl: string
    name: string
  }
}) => {
  return (
    <Box>
      <Box>
        <Text css={{ paddingLeft: 40, fontSize: 10 }}>{botUser.name}</Text>
        <Flex alignItems="flex-end">
          <UserAvatar
            imageUrl={botUser.avatarUrl}
            size="x-small"
            status="available"
          />
          <PendingMessage />
        </Flex>
      </Box>
    </Box>
  )
}

export const EndUserMessage = ({
  messageString,
  backgroundColor = '#0e71eb',
}: {
  messageString: string
  backgroundColor?: string
  isValidatedPromptType?: boolean
}) => {
  return (
    <Flex
      direction="row"
      fullWidth
      alignItems="center"
      justifyContent="flex-end"
    >
      <WidgetMessage
        messageText={messageString}
        backgroundColor={backgroundColor}
        fontColor={'#fff'}
      />
    </Flex>
  )
}
